import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'whale',
      d: 'M-2.5,-3.5h3.5v0.5h-3.5zM-3.5,-3h5.5v0.5h-5.5zM4.5,-3h2.5v0.5h-2.5zM-3.5,-2.5h6v0.5h-6zM4,-2.5h2.5v0.5h-2.5zM-4,-2h10.5v0.5h-10.5zM-4,-1.5h1v0.5h-1zM-2.5,-1.5h8v0.5h-8zM-4,-1h10.5v0.5h-10.5zM-2.5,-0.5h4.5v0.5h-4.5zM3,-0.5h1v0.5h-1zM4.5,-0.5h2v0.5h-2zM-3,0h0.5v0.5h-0.5zM0,0h1.5v1h-1.5zM2.5,0h0.5v0.5h-0.5zM4.5,0h2.5v0.5h-2.5zM-2.5,0.5h1.5v0.5h-1.5zM0.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'whaleBelly',
      d: 'M-3.5,-0.5h1v0.5h-1zM2,-0.5h1v0.5h-1zM-2.5,0h2.5v0.5h-2.5zM1.5,0h1v0.5h-1zM-1,0.5h1v0.5h-1z',
    },
    { paint: 'shadow', d: 'M-3,-1.5h0.5v0.5h-0.5z' },
    {
      paint: 'waterLight',
      d: 'M-2.5,-5.5h1v0.5h-1zM-0.5,-5.5h1.5v0.5h-1.5zM-3,-5h0.5v0.5h-0.5zM-2,-5h2v1h-2zM0.5,-5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1z',
    },
  ],
  pixels: 165,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'whale',
      d: 'M2,-5h2v0.5h-2zM5,-5h1.5v0.5h-1.5zM2,-4.5h4.5v0.5h-4.5zM2.5,-4h3.5v0.5h-3.5zM2.5,-3.5h3v0.5h-3zM2,-3h2v0.5h-2zM-2,-2.5h6v0.5h-6zM-2.5,-2h6v0.5h-6zM-3,-1.5h5.5v0.5h-5.5zM3,-1.5h0.5v0.5h-0.5zM-3.5,-1h5.5v0.5h-5.5zM2.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h4.5v0.5h-4.5zM2,-0.5h0.5v0.5h-0.5zM0,0h1v1h-1z',
    },
    {
      paint: 'whaleBelly',
      d: 'M2.5,-1.5h0.5v0.5h-0.5zM2,-1h0.5v0.5h-0.5zM1,-0.5h1v0.5h-1zM-2.5,0h2.5v0.5h-2.5zM1,0h0.5v0.5h-0.5zM-2,0.5h2v0.5h-2z',
    },
  ],
  pixels: 109,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'whale',
      d: 'M-2,-3h2.5v0.5h-2.5zM-2.5,-2.5h4v0.5h-4zM4,-2.5h1v0.5h-1zM-3,-2h5v0.5h-5zM3,-2h2v0.5h-2zM-3,-1.5h7.5v0.5h-7.5zM-3,-1h1v0.5h-1zM-1.5,-1h5.5v0.5h-5.5zM-2.5,-0.5h4v0.5h-4zM2,-0.5h2.5v0.5h-2.5zM-2.5,0h0.5v0.5h-0.5zM0,0h1v0.5h-1zM1.5,0h0.5v0.5h-0.5zM3,0h2v0.5h-2zM-1.5,0.5h1v0.5h-1zM0,0.5h1.5v0.5h-1.5zM4,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'whaleBelly',
      d: 'M1.5,-0.5h0.5v0.5h-0.5zM-2,0h2v0.5h-2zM1,0h0.5v0.5h-0.5zM-0.5,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'shadow', d: 'M-2,-1h0.5v0.5h-0.5z' },
  ],
  pixels: 92,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
